import { createStyles, Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
    createStyles({
        anchorTopLeft: {
            [theme.breakpoints.down("sm")]: {
                marginLeft: 0
            },
            left: "0%",
            marginLeft: theme.spacing(2),
            marginTop: theme.navbar.height,
            maxWidth: theme.layout.maxWidth
        },
        error: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText
        },
        success: {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.success.contrastText
        },
        notify: {
            backgroundColor: theme.palette.background.dark,
            color: theme.palette.primary.light
        }
    });
